import { PlateboardCellType, PlateboardStateType } from "@app/types/checkerboard"

export function toggleSelectCell(state: PlateboardStateType, cell: PlateboardCellType) {
	const index = state.selectedCells.findIndex(({ id }) => id === cell.id)
	if (index === -1) {
		state.selectedCells = [cell]
	} else {
		state.selectedCells = []
	}
}